/**
 * `PeopleNavContext` — ambient-сигнал «навигация к карточкам людей доступна здесь».
 *
 * Задача 82 §1.3. Имя сотрудника (`PersonNameLink`) в карточках учёта времени —
 * ссылка на `/people/$id` на десктопе, но простой текст на мобильной поверхности
 * M6: карточка `/people/$id` (`PeopleDetailPage`) живёт в офисном `AppShell` и не
 * адаптирована под узкий экран. Вместо device-sniffing в примитиве — одна точка
 * принятия: `ApprovalConsole` оборачивает тело провайдером `enabled={density ===
 * "desktop"}`, а `PersonNameLink` сам решает link vs span.
 *
 * Дефолт `enabled=true` — прочие потребители (`PeopleHubPage`, desktop-only)
 * остаются ссылками без обёртки.
 */
import * as React from "react";

const PeopleNavContext = React.createContext<boolean>(true);

export function PeopleNavProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}): React.ReactElement {
  return <PeopleNavContext.Provider value={enabled}>{children}</PeopleNavContext.Provider>;
}

/** Доступна ли навигация к карточкам людей в текущем поддереве (дефолт true). */
export function usePeopleNavEnabled(): boolean {
  return React.useContext(PeopleNavContext);
}
